import React from 'react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Loader2, AlertTriangle } from 'lucide-react';

export function DeleteCouponDialog({ open, onClose, onDelete, deletingCoupon, submitting }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle size={18} className="text-red-500" />
            Delete Coupon
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete <strong>{deletingCoupon?.code}</strong>?
            {deletingCoupon?.current_uses > 0
              ? ' It has been used before and will be archived instead of permanently deleted.'
              : ' This action cannot be undone.'}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button
            variant="destructive"
            onClick={onDelete}
            disabled={submitting}
            data-testid="confirm-delete-coupon-btn"
          >
            {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : (
              deletingCoupon?.current_uses > 0 ? 'Archive Coupon' : 'Delete Coupon'
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
